export const button = (theme) => ({
    /* Styles applied to the root element. */
    root: { fontFamily: "Spezia" },
    arrow: {
        marginLeft: 12,
        width: 32,
        height: 32,
    },
    specialText: {
        paddingLeft: theme.spacing(1),
    },
});
